import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ScrollUtil {

	static scrollToTop() {
		window.scrollTo(0, 0);
	}
}
